import { ActionTypes } from '../../constants/ActionTypes';
import { IEmployeePositionState, IReferText } from '../../interfaces';

const INIT_STATE: IEmployeePositionState = {
  referText: [],
  fastRefersEmployeePosition: [],
  fastArchiveEmployeePosition: [],
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case ActionTypes.FETCH_EMPLOYEEPOSITION_REFER_TEXT_SUCCESS: {
      // contentTypeId: 1
      // text: "ضمن عرض سلام و احترام"
      let res = action.payload.resultReferText;
      if (action.payload.search) {
        res = action.payload.resultReferText?.filter((x: IReferText) =>
          x.text.includes(action.payload.search),
        );
      }
      return {
        ...state,
        referText: res,
      };
    }

    case ActionTypes.FETCH_EMPLOYEE_POSITION_FAST_REFERS_SUCCESS: {
      return {
        ...state,
        fastRefersEmployeePosition: action.payload,
      };
    }

    case ActionTypes.FETCH_EMPLOYEE_POSITION_FAST_ARCHIVE_SUCCESS: {
      return {
        ...state,
        fastArchiveEmployeePosition: action.payload,
      };
    }

    case ActionTypes.GET_EMPLOYEEPOSITION_REFER_TEXT:
    case ActionTypes.GET_EMPLOYEE_POSITION_FAST_REFERS:
    case ActionTypes.GET_EMPLOYEE_POSITION_FAST_ARCHIVE:
    default:
      return state;
  }
};
